export enum QueryKey {
  Landing     = "landing",
  Profile     = "profile",
  Players     = "players",
  Rankings    = "rankings",
  Duels       = "duels",
  Duel        = "duel",
  Tournaments = "tournaments",
  Reports     = "reports",
  Admin       = "admin",
  Vouchers    = "vouchers",
  Config      = "config",
  Rules       = "rules",
}
